function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import StateStorage from 'farce/StateStorage';
import React, { Component, createContext } from 'react';
import ScrollBehavior from 'scroll-behavior';
var STORAGE_NAMESPACE = '@@scroll';
export var ScrollContext = /*#__PURE__*/createContext(null);
var defaultCreateScrollBehavior = function defaultCreateScrollBehavior(config) {
  return new ScrollBehavior(config);
};
var ScrollManager = /*#__PURE__*/function (_Component) {
  function ScrollManager(props) {
    var _this2;
    _classCallCheck(this, ScrollManager);
    _this2 = _callSuper(this, ScrollManager, [props]);
    _this2.prevRenderArgs = null;
    _this2.shouldUpdateScroll = function (prevRenderArgs, renderArgs) {
      var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
      if (!shouldUpdateScroll) {
        return true;
      } // Hack to allow access to ScrollBehavior internals (e.g. stateStorage).

      return shouldUpdateScroll.call(_this2.scrollBehavior, prevRenderArgs, renderArgs);
    };
    _this2.registerScrollElement = function (key, element) {
      var renderArgs = _this2.props.renderArgs;
      _this2.scrollBehavior.registerElement(key, element, _this2.shouldUpdateScroll, renderArgs);
      return function () {
        _this2.scrollBehavior.unregisterElement(key);
      };
    };
    var _props$createScrollBe = props.createScrollBehavior,
      createScrollBehavior = _props$createScrollBe === void 0 ? defaultCreateScrollBehavior : _props$createScrollBe,
      _renderArgs = props.renderArgs;
    var router = _renderArgs.router;
    _this2.scrollBehavior = createScrollBehavior({
      addNavigationListener: router.addNavigationListener,
      stateStorage: new StateStorage(router, STORAGE_NAMESPACE),
      getCurrentLocation: function getCurrentLocation() {
        return _this2.props.renderArgs.location;
      },
      shouldUpdateScroll: _this2.shouldUpdateScroll
    });
    _this2.scrollContext = {
      scrollBehavior: _this2.scrollBehavior,
      registerScrollElement: _this2.registerScrollElement
    };
    _this2.prevRenderArgs = null;
    return _this2;
  }
  _inherits(ScrollManager, _Component);
  return _createClass(ScrollManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.maybeUpdateScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.maybeUpdateScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scrollBehavior.stop();
    }
  }, {
    key: "maybeUpdateScroll",
    value: function maybeUpdateScroll() {
      var renderArgs = this.props.renderArgs;
      var prevLocation = this.prevRenderArgs && this.prevRenderArgs.location;
      if (renderArgs.location === prevLocation || !(renderArgs.elements || renderArgs.error)) {
        // If the location hasn't actually changed, or if we're in a global
        // pending state, don't update the scroll position.
        return;
      }
      this.scrollBehavior.updateScroll(this.prevRenderArgs, renderArgs);
      this.prevRenderArgs = renderArgs;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ScrollContext.Provider, {
        value: this.scrollContext
      }, this.props.children);
    }
  }]);
}(Component);
export default ScrollManager;